export const EMAIL = 'grandmaistre@gmail.com'

export const TELEPHONE = '07 81 72 84 52'
export const TELEPHONE_URL = '+33781728452'

export const ADRESSE_1 = '141 rue du Haut des Sables'
export const ADRESSE_2 = '86000 POITIERS'
